var map = {
	"./CateringWorld_Vivaro.jpg": 2561,
	"./DLTimber_CrafterMWB.jpg": 7917,
	"./GlasgowLogistics_Master.jpg": 7408,
	"./Norelo_Ranger.jpg": 3194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 831;